import { InfoBoxModel, LayoutStateModel } from './models';

export const getInfoBoxData = (state: LayoutStateModel): InfoBoxModel => {
  return state.infoBoxData;
};
